import React, { useState, useEffect } from "react"
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import Slider from "react-slick"

import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS } from "@contentful/rich-text-types"

import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../shared/utils/userInfo'

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./body-consulting.scss"

const BodyConsulting = props => {
  const { mobile, beneficios, especialistas } = props
  const { homeLink } = useHomeLinkMode();
  const [slidesToShow, setSlidesToShow] = useState(1)

  useEffect(() => {
    if (especialistas.length > 1) {
      setSlidesToShow(especialistas.length > 2 ? 3 : 2)
    }
  }, [])

  var settings1 = {
    infinite: true,
    slidesToShow: mobile ? 1 : 3,
    dots: mobile ? true : false,
    slidesToScroll: 1,
    arrows: false,
    // centerMode: mobile ? true : false
  }

  const options = {
    renderNode: {
      [BLOCKS.UL_LIST]: (node, next) => (
        <Slider className="f-top-info-container" {...settings1}>
          {" "}
          {next}
        </Slider>
      ),
      [BLOCKS.LIST_ITEM]: (node, next) => (
        <div>
          {" "}
          <div className="f-box">{next}</div>
        </div>
      ),
      [BLOCKS.PARAGRAPH]: (node, next) => (
        <div className="f-text-box-container">
          <p className="f-text">{next}</p>
        </div>
      ),
      [BLOCKS.EMBEDDED_ASSET]: (node, next) =>
        <span className="f-cicle-container">
          <img
            src={
              node.data.target.fields.file[process.env.LOCALE] ?
                node.data.target.fields.file[process.env.LOCALE].url :
                node.data.target.fields.file["es-CO"].url
            }
            alt={
              node.data.target.fields.description[process.env.LOCALE] ?
                node.data.target.fields.description[process.env.LOCALE] :
                node.data.target.fields.description["es-CO"]
            } />
        </span>,
    },
  }

  const optionsEspecialosta = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, next) => (
        <p className="f-card-description">{next}</p>
      ),
    },
  }

  var settings2 = {
    infinite: true,
    slidesToShow: mobile ? 1 : slidesToShow,
    dots: !!mobile,
    slidesToScroll: 1,
    arrows: mobile ? true : false,
  }

  const handleRedirection = _link => {
    window.location.href = homeLink + 'asesoria/consultorio/' + _link;
  }

	const userInfo=dataLayerUserInfo()
	const dataLayerConsultar = () => {      
			let location=''
			if (window) {
					location= window.location.href
			}
			pushDataLayerEvent({event: 'Interacciones - Asesoría',
			category: 'consultorio',
			action: 'click',
			label: 'Consultar',
			location: location,
			user_data: userInfo.user_data? userInfo.user_data: '',
			log_status: userInfo.log_status,})
	}

  return (
    <div className="f-body-consulting">
      {documentToReactComponents(beneficios.json, options)}

      <Slider className="f-cards-container" {...settings2}>
        {especialistas.map((consultorio, index) => {
          var color = "";
          if (consultorio.nombreEspecialista === 'Diana Vahos') {
            color = "green"
          }
          return (
            <div className="f-consulting-card-container" key={index}>
              <div className="f-consulting-card">
                <div className="f-consulting-img-container">
                  <img
                    src={consultorio.imagenDeEspecialistaHome.file.url}
                    alt={consultorio.imagenDeEspecialistaHome.description}
                  />
                </div>
                <label className={"f-card-title " + color}>
                  {consultorio.nombreEspecialista}
                </label>
                {documentToReactComponents(
                  consultorio.descripcionEspecialistaHome.json,
                  optionsEspecialosta
                )}

                <button onClick={() => { dataLayerConsultar(); handleRedirection(consultorio.slug) }} to={consultorio.slug}>
                  <div className={"f-card-button " + color}>
                    {consultorio.nombreBotonEspecialista}
                  </div>
                </button>
              </div>
            </div>
          )
        })}
      </Slider>
    </div>
  )
}

export default BodyConsulting
